<template functional>
  <v-toolbar
    :scroll-threshold="60"
    clipped-left
    scroll-off-screen
    extended
    fixed
    tabs
    dark
    :app="!props.modal"
    id="nx-editor-header"
    color="nx-primary--darken-2"
    class="mt-5"
  >
    <v-layout shrink justify-content-start>
      <slot name="info"></slot>
    </v-layout>
    <v-layout grow align-center justify-end class="ml-2">
      <slot name="chips"></slot>
      <slot name="tools"></slot>
    </v-layout>
    <template slot="extension">
      <slot name="extension"></slot>
    </template>
  </v-toolbar>
</template>

<script>

/**
 * @slot #info left side of the toolbar
 * it usually contains info about content's
 * publication or schedule state
 * @slot #chips spaced after info it contains
 * chips and visual representation of content's state
 * @slot #tools content's tools like actions or displaying
 * metadata details
 * @slot #extension right after header/toolbar. Always
 * have content's channels and state buttons (publish, save, etc)
 */

export default {
  name: 'nx-content-editor-header',
  props: {
    modal: Boolean,
  },
};
</script>

<style lang="stylus">
  #nx-editor-header {
    z-index: 2; // Lower than the app navigation, but higher than the advanced editor toolbar.
    .v-toolbar__extension {
      position: relative;
    }
  }
</style>
